/**
 * Dashboard React Query keys。
 */
export function dashboardOverviewQueryKey(range, currencyId, trendMonths) {
  return ['erp', 'dashboard', 'overview', range ?? null, currencyId || null, trendMonths ?? null];
}

export function dashboardModuleQueryKey(moduleKey, query) {
  return ['erp', 'dashboard', moduleKey, query];
}
